import React, { type FunctionComponent, useEffect, useState } from 'react'
import styled from '@emotion/styled'
import RegionLocationProvider from 'legacy/contexts/regionLocation/RegionLocationProvider'
import WarehouseProvider from 'utils/contexts/warehouse/WarehouseProvider'
import ErrorBoundary from 'legacy/components/ErrorBoundary'
import { type RetailerScopedRouteParams } from 'legacy/common/types'
import { type DashRouteComponentProps } from 'legacy/dash-components/dash-route/utils/dashRoute.types'
import WarehousesProvider from 'legacy/contexts/warehouses/WarehousesProvider'
import { RetailerScopedRoutes } from 'routes/logged-in/partner-scoped/retailer-scoped/RetailerScopedRoutes'
import { RetailerNav } from 'gin-and-tonic/containers/nav/RetailerNav'
import { Z_INDEX_THIRD, DASH_NAV_WIDTH } from 'legacy/common/theme'
import { AppContentContainer } from 'gin-and-tonic/containers/app-content-container/AppContentContainer'
import { usePickupTourStatus } from 'domains/pickup-settings/training-tour/usePickupTourStatus'
import { WelcomeModal } from 'gin-and-tonic/common/TrainingModal/WelcomeModal'
import { useHideNavbarDueToPendingOnboarding } from 'domains/onboarding'

interface Props extends DashRouteComponentProps<RetailerScopedRouteParams> {}

const NavContainer = styled.aside({
  position: 'fixed',
  height: '100%',
  display: 'flex',
  width: DASH_NAV_WIDTH,
  top: 0,
  left: 0,
  zIndex: Z_INDEX_THIRD,
})

export const RetailerScopedSection: FunctionComponent<Props> = ({
  match: {
    params: { warehouse_id: warehouseId },
  },
  location: { pathname },
}) => {
  const { isTourPending, isTourShown } = usePickupTourStatus('pickup_overview')
  const [isWelcomeModalOpen, setIsWelcomeModalOpen] = useState(false)

  useEffect(() => {
    if (isTourPending && !isTourShown) {
      // setIsWelcomeModalOpen(true)
    }
  }, [isTourPending, isTourShown])

  const hideNavBar = useHideNavbarDueToPendingOnboarding()

  return (
    <WarehousesProvider>
      <WarehouseProvider id={warehouseId}>
        <RegionLocationProvider>
          {!hideNavBar && (
            <NavContainer>
              <RetailerNav />
            </NavContainer>
          )}
          <AppContentContainer>
            <ErrorBoundary pathname={pathname}>
              <WelcomeModal
                onClose={() => setIsWelcomeModalOpen(false)}
                onConfirm={() => {
                  setIsWelcomeModalOpen(false)
                }}
                isOpen={isWelcomeModalOpen}
              />
              <RetailerScopedRoutes />
            </ErrorBoundary>
          </AppContentContainer>
        </RegionLocationProvider>
      </WarehouseProvider>
    </WarehousesProvider>
  )
}
